import React from 'react';
import {
    PromotionSlideComponent
} from "../../../components/video-slides/slides-types/promotion/promotion-slide.component";
import {IAfterActivateSlideRendererContext, IBeforeDeactivateSlideRendererContext,
    ISlideRenderer
} from "../video-slides.service.interface";

export class PromotionSlideRenderer implements ISlideRenderer {
    constructor(private readonly _uniqueKey: string) {

    }

    onBeforeDeactivate(context: IBeforeDeactivateSlideRendererContext): void {

    }
    onAfterActivated(context: IAfterActivateSlideRendererContext): void {
        
    }

    get uniqueKey(): string {
        return this._uniqueKey;
    }

    isLoading = false;

    render(): React.ReactElement {
        return <PromotionSlideComponent key={this.uniqueKey} />
    }

}